import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', to: '/' },
  { label: '全部分类', to: '/categories' },
  { label: '关于我们', to: '/about' },
  { label: '联系反馈', to: '/contact' },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
    setMenuOpen(false);
  };

  const isActive = (to: string) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full h-16 md:h-[72px] px-4 md:px-8 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" onClick={() => setMenuOpen(false)}>
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
            <i className="ri-planet-line"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold text-foreground-950 tracking-wide">在线</span>
            <span className="text-[10px] text-foreground-500 mt-0.5 hidden sm:block">多元化在线服务平台</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 text-sm rounded-md transition-colors cursor-pointer ${
                isActive(link.to)
                  ? 'text-primary-600 font-semibold bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <form onSubmit={handleSearch} className="hidden md:flex items-center relative">
            <i className="ri-search-line absolute left-3 text-foreground-400 text-base"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索课程、活动、优惠…"
              className="w-52 lg:w-64 pl-9 pr-3 py-2 text-sm rounded-full bg-background-100 border border-background-200 focus:border-primary-400 focus:bg-background-50 focus:outline-none text-foreground-900 placeholder:text-foreground-400"
            />
          </form>

          <Link
            to="/categories"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 text-sm rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-apps-2-line"></i>
            分类导航
          </Link>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <form onSubmit={handleSearch} className="relative mb-3 md:hidden">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索课程、活动、优惠…"
              className="w-full pl-9 pr-3 py-2.5 text-sm rounded-full bg-background-100 border border-background-200 focus:border-primary-400 focus:outline-none"
            />
          </form>
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className={`px-4 py-3 text-sm rounded-md ${
                  isActive(link.to)
                    ? 'text-primary-600 font-semibold bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}